import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AppShell from './AppShell';

/**
 * Layout route for every authenticated page.
 *
 * Renders the app shell (left navigation) once and the matched page inside it,
 * so moving between modules swaps only the page — the navigation stays put and
 * its counts are not re-fetched on every click.
 *
 * The card check stays on the individual routes (`ProtectedRoute`); this only
 * answers "is anyone signed in", and redirects before the shell renders so an
 * unauthenticated visitor is never shown a menu.
 */
const ProtectedShell = () => {
    const { user, token } = useAuth();

    if (!token || !user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <AppShell>
            <Outlet />
        </AppShell>
    );
};

export default ProtectedShell;
